var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "post-privacy" },
    [
      _c("vue-select", {
        staticClass: "privacy",
        attrs: {
          placeholder: "All Connections",
          options: _vm.privacy_options,
          label: "name",
          reduce: function(option) {
            return option.value
          },
          value: _vm.privacy,
          clearable: false,
          searchable: false
        },
        on: {
          input: function($event) {
            return _vm.$emit("change_privacy", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }